/* eslint-disable no-magic-numbers */
import React, { ReactNode } from 'react';

import { SceneData } from '../api/sxp';
import { createContext } from '../context';
import { useGlobalNav } from './hooks/useGlobalNav';
import { useGlobalNavStatus } from './hooks/useGlobalNavStatus';
import { useOneTrustPrefsSync } from './hooks/useOneTrustPrefsSync';
import { useSbcConfig } from './hooks/useSbcConfig';
import { useSceneData } from './hooks/useSceneData';

interface SxpContextProps {
  children?: ReactNode;
}

interface SxpContextValues {
  displayGlobalNav: boolean;
  sceneData?: SceneData;
  onlyExternalOrgs: boolean;
  onlySfAOrgs: boolean;
  sbcBaseUrl?: string;
}

export const { Provider: SxpContextProvider, useContext: useSxpContext } = createContext<SxpContextValues>();

export const SxpContext = ({ children }: SxpContextProps) => {
  const { displayGlobalNav, onlyExternalOrgs, onlySfAOrgs } = useGlobalNavStatus();
  const { config } = useSbcConfig();
  const sceneData = useSceneData(displayGlobalNav, config);

  useGlobalNav(displayGlobalNav, config);
  useOneTrustPrefsSync(sceneData?.User?.Id, config);

  const values = {
    displayGlobalNav,
    sceneData,
    onlyExternalOrgs,
    onlySfAOrgs,
    sbcBaseUrl: config?.sbc_base_url
  };

  return <SxpContextProvider value={values}>{children}</SxpContextProvider>;
};
